/**
 * Tab contract of Minha Lais: valid ids, legacy aliases kept for deep links,
 * accessibility ids and roving-focus keyboard navigation.
 *
 * Pure helpers only — the page owns router/query sync and data loading.
 */

export const VALID_TABS = [
  'geral',
  'whatsapp',
  'brand_voice',
  'automacoes_ia',
  'testes',
];

export const LEGACY_TAB_ALIASES = {
  atendimento: 'geral',
  origens: 'geral',
  notificacoes: 'geral',
  aparencia: 'geral',
  qualificacao: 'automacoes_ia',
  crm: 'testes',
};

export const DEFAULT_TAB = 'geral';

export const routeQueryValue = value =>
  Array.isArray(value) ? value[0] : value;

export const normalizeTab = value => {
  const queryValue = routeQueryValue(value);
  if (VALID_TABS.includes(queryValue)) return queryValue;
  return LEGACY_TAB_ALIASES[queryValue] || DEFAULT_TAB;
};

export const shouldPrimeLegacyNotifications = value =>
  routeQueryValue(value) === 'notificacoes';

export const VALID_WHATSAPP_SUBTABS = [
  'conexao_qr',
  'onboarding_meta',
  'perfil',
  'operacoes',
];

export const normalizeWhatsappSubTab = value => {
  const queryValue = routeQueryValue(value);
  return VALID_WHATSAPP_SUBTABS.includes(queryValue)
    ? queryValue
    : 'conexao_qr';
};

export const tabButtonId = tabId => `minha-lais-tab-${tabId}`;

export const tabPanelId = tabId => `minha-lais-panel-${tabId}`;

export const whatsappSubTabButtonId = subTabId =>
  `minha-lais-whatsapp-tab-${subTabId}`;

export const whatsappSubTabPanelId = subTabId =>
  `minha-lais-whatsapp-panel-${subTabId}`;

export const focusElementById = elementId => {
  if (typeof document === 'undefined') return;

  const focusElement = () => document.getElementById(elementId)?.focus();
  if (typeof window !== 'undefined' && window.requestAnimationFrame) {
    window.requestAnimationFrame(focusElement);
    return;
  }
  focusElement();
};

export const nextKeyboardTabIndex = (event, currentIndex, total) => {
  if (event.key === 'Home') return 0;
  if (event.key === 'End') return total - 1;
  if (event.key === 'ArrowRight') return (currentIndex + 1) % total;
  if (event.key === 'ArrowLeft') return (currentIndex - 1 + total) % total;
  return null;
};
